import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { OmsRoutingModule } from './oms-routing.module';
import { OmsComponent } from './oms.component';
import { OmsListComponent } from './oms-list/oms-list.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
//import { SharedModule } from 'projects/common-resource';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { OmsReturnComponent } from './oms-return/oms-return.component';
import { OmsDetailsComponent } from './oms-details/oms-details.component';
import { OmsReturnConfirmComponent } from './oms-return/oms-return-confirm/oms-return-confirm.component';
import { OrderInprogressDetailsComponent } from './order-inprogress-details/order-inprogress-details.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { icons, LucideAngularModule } from 'lucide-angular';
import { ElementsModule } from 'src/app/shared/elements/elements.module';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';

@NgModule({
  declarations: [
    OmsComponent,
    OmsListComponent,
    OmsReturnComponent,
    OmsDetailsComponent,
    OmsReturnConfirmComponent,
    OrderInprogressDetailsComponent,
    InvoiceDetailsComponent
  ],
  imports: [
    CommonModule,
    OmsRoutingModule,
    MaterialModule,
    CdkAccordionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    //SharedModule,
    FormsModule,
    ElementsModule,
    LucideAngularModule.pick(icons),
  ],
})
export class OmsModule {}
